module.exports = __webpack_public_path__ + "img/brede-bevestiging.a30a2672.jpg";